import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 1rem;
  padding-bottom: 3rem;
  padding-top: 102px;
  gap: 60px;
  height: 100%;
  justify-content: space-between;

  ${themeMedia.desktop`
    justify-content: start;
    padding-top: 50px;
    padding-bottom: 1rem;
  `}
`

export const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 30px;

  p {
    font-size: 22px;
    text-align: center;
  }

  ${themeMedia.desktop`
    flex-direction: column;
  `}
`

export const StyledIcon = styled.img`
  width: 100px;
`

export const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const StyledTitle = styled.p`
  font-weight: 400;
  margin: 0;

  ${themeMedia.desktop`
    font-size: 25px !important;
  `}
`
